<!--
    描述：选择上级人员弹框
    时间：2020-04-24
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<search-area ref="searchContent"
							 v-model="searchForm.sname"
							 :showMore="false"
							 placeholderName="员工姓名"
							 @on-search="onSearch"
							 @on-refresh="onRefresh"
							 @on-reset="onReset">
				</search-area>
			</div>
			<div class="w-page-container">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content"
						 ref="usersContent">
						<el-table v-loading="usersData.loading"
								  :data="usersData.tableData"
								  :border="true"
								  :height="usersData.tableH"
								  ref="softWareTable"
								  highlight-current-row
								  @row-dblclick="cblClick">
							<el-table-column type="index"
											 align="center"
											 width="50"></el-table-column>
							<el-table-column prop="sname"
											 align="center"
											 label="人员姓名"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="username"
											 align="center"
											 label="用户名"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="deptName"
											 align="center"
											 label="部门"
											 show-overflow-tooltip
											 min-width="150"></el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer text-center">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="usersData.currentPage"
									   :page-sizes="usersData.pageList"
									   :page-size="usersData.pageSize"
									   layout="total, sizes, prev, pager, next, jumper"
									   :total="usersData.total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getUsers } from '@/api/modules/user.js'
import searchArea from '@/components/searchArea/searchArea'

export default {
	components: { searchArea },
	data() {
		return {
			usersData: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			searchForm: {
				sname: ''
			}
		}
	},
	methods: {
		getUsers() {
			let param = {}
			param.sname = this.searchForm.sname
			param.current = this.usersData.currentPage
			param.size = this.usersData.pageSize
			getUsers(param).then(res => {
				this.usersData.tableData = res.data.records
				this.usersData.total = parseInt(res.data.total)
			})
		},

		//双击列表行事件
		cblClick(row) {
			this.$emit('on-selected', row)
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.usersData.pageSize = val
			this.getUsers()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.usersData.currentPage = cur
			this.getUsers()
		},

		// 确认搜索
		onSearch() {
			this.getUsers()
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.sname = ''
		}
	},

	created() {
		this.getUsers()
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.usersData.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize })
	},

	watch: {
		clientSize(val) {
			this.usersData.tableH = this.$refs.usersContent.offsetHeight
		}
	}
}
</script>
<style lang="less">
.superiors-search-area {
	.search-area-layout {
		@mainHeight: 32px;
		display: flex;
		align-items: center;

		.el-input {
			width: 557px;
		}

		.el-input__inner {
			height: @mainHeight;
			line-height: @mainHeight;
		}

		.el-input-group__append {
			color: #fff;
			background-color: #008080;
		}
	}
}
</style>
